import React, { useState, useRef, useEffect } from "react"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { t } from "i18next";
import { Card } from "react-bootstrap";
import Organization from "../../utilities/components/Organization";
import InputText from "../../utilities/components/InputText";
import { englishToNepaliNumber } from "nepali-number";
import InputTextNepali from "../../utilities/components/InputText";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import i18n from "../../il8n/il8n";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import {
    FORM_MODE,
    ID_CATEGORY_NEPALI,
    LANGUAGE,
} from "../../utilities/constants/ITMISConstansts";
import { Dropdown } from "primereact/dropdown"
import { fill } from "pdf-lib";
import { trackPromise } from "react-promise-tracker";
import { data } from "jquery";
import DisabilityCardDetailServices from "../api/services/DisabilityCardDetailService";
import { PropaneSharp } from "@mui/icons-material";
import { resetWarningCache } from "react-summernote";

const SeniorCitizenAndDetail= () => {
    const {
        control,
        formState: { errors },
        handleSubmit,
        setValue,
    } = useForm({});
    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>;
    };

    const [organization, setOrganization] = useState("");

    const handleOrganization = (organizationId) => {
        setOrganization(organizationId);
    };
    const searchData = () => {
    }

    // if (props.location.state && props.location.state.id) {
    //     (props.location.state && props.location.state.id
    //     ).then((response) => {
    //         if (response.status == 200) {
    //             reset({
    //                 id: response.data.data.id,
    //                 nameEng: response.data.data.disabilityApprovedDetail.nameEng,
    //                 nameNep: response.data.data.disabilityApprovedDetail.nameNep,
    //                 designationEng: response.data.data.disabilityApprovedDetail.designationEng,
    //                 designationNep: response.data.data.disabilityApprovedDetail.designationNep,
    //                 officeNep: new Date(response.data.data.disabilityApprovedDetail.officeNep),
    //                 officeEng: response.data.data.disabilityApprovedDetail.officeEng,
    //             })
    //         }
    //     }
    //     )
    // }
    const toast = useRef(null);

    //To Save Data
    const submitData = (data) => {
        console.log("data", data);
        data.status = "Submit";

        DisabilityCardDetailServices.save(data)
            .then((response) => {
                console.log("response", response);
                if (response.status === 200) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Save successful",
                        life: 3000,
                    })
                    // window.location.reload(false);
                }
            }).catch((error) => {
                // We want to handle globally
                console.log("error", error);
            })

    }

    return (
        <>
            <div class="p-card p-component p-mb-1" style={{ borderRadius: "8px 8px 0px 0px", background: "#f7f7f8" }}>
                <div class="p-card-body">
                    <div className="p-card-content">
                        <h4 className="p-pt-0">{t("Senior Citizen And Details")}</h4>
                    </div>
                </div>
            </div>
            <div class="p-card p-component p-mt-0">
                <div className="p-card-body">
                    <div className="p-card-content">
                        <form className="p-grid p-fluid" >
                            <Organization submitOrganizationId={handleOrganization} />
                            <div className="p-field p-col-12 p-md-12 ">
                                <div className="p-field p-col-10 p-md-10 float-left"></div>
                                <div className="p-field p-col-2 p-md-2 float-right">
                                    <Button
                                        style={{
                                            justifyContent: "center",
                                            alignItems: "center",
                                            background: "#1c80cf",
                                            color: "#FFF",
                                        }}
                                        label={t("search")}
                                        onClick={handleSubmit(searchData)}
                                    />
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-12 ">
                                <hr style={{ margin: "5px" }}></hr>
                            </div>
                            <div className="p-field p-col-12 p-md-12 float-left">
                                <div className="p-field p-col-12 p-md-12 float-left" style={{ fontWeight: "bold" }}>
                                    {t("verifyingOfficer")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-12 float-left">
                                <div class="p-field p-col-12 p-md-12 float-left main-label">{t("name")}<span style={{ color: "#d00000" }}> * </span></div>
                                <div class="p-field p-col-6 p-md-6 float-left">
                                    <Controller
                                        name="nameEng"
                                        control={control}
                                        rules={{ required: "Name is required." }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                {...field}
                                                className="rounded-input p-mb-1"
                                                placeholder="English"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("nameEng")}
                                </div>
                                <div class="p-field p-col-6 p-md-6 float-left">
                                    <Controller
                                        name="nameNep"
                                        control={control}
                                        rules={{ required: "Name is required." }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                {...field}
                                                className="rounded-input p-mb-1"
                                                placeholder="नेपाली"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("nameNep")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-12 float-left">
                                <div class="p-field p-col-12 p-md-12 float-left main-label">{t("designation")}<span style={{ color: "#d00000" }}> * </span> </div>
                                <div class="p-field p-col-6 p-md-6 float-left">
                                    <Controller
                                        name="designationEng"
                                        control={control}
                                        rules={{ required: "Designation is required." }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                {...field}
                                                className="rounded-input p-mb-1"
                                                placeholder="English"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("designationEng")}
                                </div>
                                <div class="p-field p-col-6 p-md-6 float-left">
                                    <Controller
                                        name="designationNep"
                                        control={control}
                                        rules={{ required: "Designation is required." }}
                                        render={({ field, fieldState }) => (
                                            <InputText
                                                id={field.name}
                                                {...field}
                                                className="rounded-input p-mb-1"
                                                placeholder="नेपाली"
                                            />
                                        )}
                                    />
                                    {getFormErrorMessage("designationNep")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-12 float-left">
                                <div class="p-field p-col-10 p-md-10 float-left">&nbsp;</div>
                                <div class="p-field p-col-2 p-md-2 float-right">
                                    <Button label={t("save")} onClick={handleSubmit(submitData)}
                                        style={{ background: "#4e70ae", color: "#FFF", justifyContent: "center" }}
                                    >  </Button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div >
        </>

    );
}
export default SeniorCitizenAndDetail;
